const scriptAttributes = {
    position: 'data-position',
    dialog: 'data-dialog',
    zIndex: 'data-z-index',
};
export const getScriptAttribute = (name, defaultValue) => { var _a, _b; return (_b = (_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.getAttribute(scriptAttributes[name])) !== null && _b !== void 0 ? _b : defaultValue; };
